const doc = [({"zh_cn":({"adminConstantPromotionApplicableConditionType":({"hotel":"全部", "hotelPlan":"计划指定", "hotelPlanAndHotelRoom":"平面图和房型规格", "hotelRoom":"房型规格"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;